<style lang="scss" scoped>
.avatar {
	// margin-top: 20px;
	&__remove {
		padding: 20px;
		border-radius: 4px;
		border: 1px dashed #bfcbd9;
		font-weight: bold;
		display: inline-block;
		color: $headerColor;
		font-size: 14px;
		cursor: pointer;
		&:hover {
			background: #f0f1f4;
		}
		&__img {
			display: inline-block;
		}
		i {
			margin-right: 8px;
			font-size: 20px;
			position: relative;
			top: 3px;
			margin-left: 20px;
		}
	}
}
</style>

<template lang="pug">
    .avatar
        template(v-if="value && value.value")
            .avatar__remove(@click="deleteIcon()")
                class-icon(class="avatar__remove__img", :icon="value")
                i.fa.fa-times
                | Remove image
        template(v-else)
            .avatar__selector
                this-or-that(@leftClick="open('emojis')", @rightClick="open('upload')")
                    template(slot="left")
                        img(src="https://edu.wonde.com/emoji-assets/64/1f601.png")
                        label Pick Emoji
                    template(slot="right")
                        img(src="/static/img/icons/upload-file.png")
                        label Upload Image
</template>

<script>
import { cloneDeep } from "lodash";
import ThisOrThat from "@/components/ui/ThisOrThat";
import Icons from "@/components/classroom/create/AvatarSelector/Icons";
import Emojis from "@/components/classroom/create/AvatarSelector/Emojis";
import Upload from "@/components/classroom/create/AvatarSelector/Upload";
import ClassIcon from "@/components/classroom/ClassIcon";

export default {
	components: {
		ClassIcon,
		ThisOrThat
	},
	props: {
		value: {
			type: Object,
			default: () => ({
				type: null,
				value: null
			})
		}
	},
	methods: {
		open(type) {
			const Vue = this;
			let component, title;

			switch (type) {
				case "icons":
					component = Icons;
					title = "Pick icon";
					break;
				case "emojis":
					component = Emojis;
					title = "Pick Emoji icon";
					break;
				case "upload":
					component = Upload;
					title = "Upload your own icon";
					break;
			}

			this.$vuedals.open({
				component,
				title,
				size: "md",
				props: {
					icon: this.value || undefined
				},
				onClose(icon) {
					Vue.$emit("input", icon);
				}
			});
		},
		deleteIcon() {
			this.$emit("input", null);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/classroom/create/AvatarSelector.vue